function capitalizeEveryWord(inputString) {
  // Split the string into words
  const words = inputString.split(' ');

  // Capitalize the first letter of each word
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));

  // Join the words back together with a space
  const capitalizedString = capitalizedWords.join(' ');

  return capitalizedString;
}

export const formatRoomDescription = (roomDescription) => {
  if (!roomDescription) return '';
  let newRoomDescription = roomDescription;

  // Replace common abbreviations
  newRoomDescription = newRoomDescription.replace(/NON-REFUNDABLE/g, 'Non-refundable');
  newRoomDescription = newRoomDescription.replace(/NON-CHANGEABLE/g, 'Non-changeable');
  newRoomDescription = newRoomDescription.replace(/PREPAY IN FULL/g, 'Prepay in full');
  newRoomDescription = newRoomDescription.replace(/-S-/g, '');
  newRoomDescription = newRoomDescription.replace(/\*/g, ' - ');

  newRoomDescription = newRoomDescription.toLowerCase();

  // Split the text into sentences
  const sentences = newRoomDescription.split('. ');

  // Capitalize the first letter of each sentence
  const formattedSentences = sentences
    .map((sentence) => sentence.charAt(0).toUpperCase() + sentence.slice(1));

  // Join the sentences back together
  const formattedText = formattedSentences.join('. ');

  return capitalizeEveryWord(formattedText);
};

const commissionTerms = [
  'commissionable',
  'commission'];

const commissionPatterns = [
  {
    regex: new RegExp('\\d+\\s*(percent\\s*(commissionable|comm)|pct\\s*comm)', 'gi'),
  },
  {
    regex: new RegExp('\\d+\\s*pct\\s*comm', 'gi'),
  },
  {
    regex: new RegExp(`\\b(${commissionTerms.join('|')})\\b`, 'gi'),
  },
];

export const removeCommissionTerms = (text) => {
  if (!text) return '';
  let cleaned = text;

  commissionPatterns.forEach(({ regex }) => {
    cleaned = cleaned.replace(regex, '');
  });

  return cleaned.trim();
};
